module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 1